module.exports = __webpack_public_path__ + "media/video-isun-intro.4fdf844f.mp4";